<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="业务类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['businessType', validatorRules.businessType]" :trigger-change="true" :options="businessTypeDict" placeholder="请选择业务类型"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="项目组" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['project']" :trigger-change="true" dictCode="bms_project" placeholder="请选择项目组"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="立项名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-search-select-tag type="list" v-decorator="['projectInfoId', validatorRules.projectInfoId]" :trigger-change="true"
                                   dict="active,projectNameItems,value1,value2" placeholder="项目立项名称，运维类型必填"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="投保人" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['insure', validatorRules.insure]" placeholder="请输入投保人"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="被保险人" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['insured', validatorRules.insured]" placeholder="请输入被保险人"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="被保险人联系方式" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['insuredTel', validatorRules.insuredTel]" placeholder="请输入被保险人联系方式"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="被保险人通讯地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['insuredAddr', validatorRules.insuredAddr]" placeholder="请输入被保险人通讯地址"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="保险公司" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-search-select-tag
                placeholder="请选择保险公司"
                v-decorator="['insurerNumber', validatorRules.insurerNumber]"
                :trigger-change="true"
                dict="biz_insurance_company,name,code">
              </j-search-select-tag>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="标的类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['productOrLife', validatorRules.productOrLife]" :trigger-change="true" dictCode="product_or_life" placeholder="请选择标的类型"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="标的名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['subjectName', validatorRules.subjectName]" placeholder="请输入标的名称"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="险种名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-search-select-tag v-decorator="['insuranceName', validatorRules.insuranceName]" :trigger-change="true"
                dict="biz_insurance_with_type,insurance_name,insurance_name" 
                placeholder="请输入险种全称"></j-search-select-tag>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="险种类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag ref="insuranceType" type="list"
                                 v-decorator="['insuranceType', validatorRules.insuranceType]" :trigger-change="true"
                                 dictCode="bms_insurance_type" placeholder="险种类型" disabled />
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item label="车牌号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['car', validatorRules.car]" disabled placeholder="请输入车牌号"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="保险起期" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择保险起期" disabled v-decorator="['insuranceStart', validatorRules.insuranceStart]" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="保险讫期" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择保险讫期" disabled v-decorator="['insuranceEnd', validatorRules.insuranceEnd]" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="保单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['policy', validatorRules.policy]" disabled placeholder="请输入保单号"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="批单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['endNum', validatorRules.endNum]" placeholder="请输入批单号"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="保额(元)" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['insuredAmount', validatorRules.insuredAmount]"
                              :formatter="moneyFormatter" :parser="moneyParser"
                              placeholder="请输入保额" style="width: 100%;"></a-input-number>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="费率(‰)" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator.number="['rate', validatorRules.rate]" placeholder="请输入费率(单位‰)" style="width: 100%"></a-input-number>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="保费(元)" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator.number="['premium', validatorRules.premium]" :formatter="moneyFormatter" :parser="moneyParser" placeholder="请输入保费" style="width: 100%"></a-input-number>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="去税保费(元)" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator.number="['cleanPremium', validatorRules.cleanPremium]" :formatter="moneyFormatter" :parser="moneyParser"
                placeholder="请输入去税保费" style="width: 100%">
              </a-input-number>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="佣金是否含税" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['includeTax', validatorRules.includeTax]"
                                 :trigger-change="true" dictCode="bms_include_tax" placeholder="保司结算的佣金是否含税"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="缴费类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['lifeInsurancePayType']"  :trigger-change="true"
                                 dictCode="bms_life_insurance_pay_type" placeholder="请输入缴费类型"
                                 />
            </a-form-item>
          </a-col>
          <a-col :span="24"> <!-- @change="brokerageRatioChange" -->
            <a-form-item label="佣金比例(%)" :labelCol="labelCol" :wrapperCol="wrapperCol"> 
              <a-input-number :min="0" :max="100" v-decorator.number="['brokerageRatio', validatorRules.brokerageRatio]"
                              
                              placeholder="请输入佣金比例" style="width: 100%"></a-input-number>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="总佣金(元)" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['brokerageTotal', validatorRules.brokerageTotal]"
                              :formatter="moneyFormatter" :parser="moneyParser" placeholder="请输入总佣金" style="width: 100%"
                              ></a-input-number>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item label="开票金额(元)" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['invoiceAmount', validatorRules.invoiceAmount]"
                              :formatter="moneyFormatter" :parser="moneyParser" placeholder="请输入开票金额" style="width: 100%"
                              @change="handleInvoiceAmountChange"
                              ></a-input-number>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="票外金额(元)" :labelCol="labelCol" :wrapperCol="wrapperCol" >
              <a-input-number disabled v-decorator="['outsideInvoiceAmount', validatorRules.outsideInvoiceAmount]" :formatter="moneyFormatter" placeholder="请输入票外金额" style="width: 100%"></a-input-number>
            </a-form-item>
          </a-col><!--V11-->
          <a-col :span="24">
            <a-form-item label="发票税率(%)" :labelCol="labelCol" :wrapperCol="wrapperCol" >
              <a-input-number v-decorator="['taxRate', validatorRules.taxRate]" placeholder="请输入发票税率" style="width: 100%"></a-input-number>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="开票单位" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select
                v-decorator="[ 'invoiceUnit', validatorRules.invoiceUnit]"
                placeholder="请选择开票单位"
                :getPopupContainer = "(target) => target.parentNode">
                <a-select-option v-for="(item) in invoiceUnits" :value="item.orgCode" :key="item.orgCode">{{item.departName}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="期数" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['phase',validatorRules.phase]" placeholder="请输入期数"></a-input>
            </a-form-item>
          </a-col>
<!--          <a-col :span="24">
            <a-form-item label="合作机构" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['institution']" disabled :trigger-change="true" dictCode="bms_institution" placeholder="请选择合作机构"/>
            </a-form-item>
          </a-col>-->
          <a-col :span="24">
            <a-form-item label="区域" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['zone', validatorRules.zone]" disabled placeholder="请输入区域"></a-input>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item label="所属渠道" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['channel']" :trigger-change="true" disabled dictCode="bms_channel" placeholder="直属渠道" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="互联网标识" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['internet']" :trigger-change="true" disabled dictCode="bms_internet" placeholder="传统业务" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="涉农标识" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['agFlag']" :trigger-change="true"  disabled  dictCode="bms_agFlag" placeholder="非农业险" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="附件" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-tooltip>
                <template slot="title">
                  1. 文件名只能包含字母、数字、下划线、连字符、点号。不能包含空格或其他特殊字符<br>
                  2. 文件名不能以点号(.)或者下划线(_)开头或结尾<br>
                  3. 文件名不能有两个以上的点号(.)<br>
                  4. 常见的特殊字符有：标点符号、数学符号、货币符号、空格、引号等等
                </template>
                <j-upload v-decorator="['file']" :trigger-change="true"  bizPath="achievement" :disabled="formDisabled" @change="handleFileChange"></j-upload>
              </a-tooltip>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item>
              <div style="border-bottom: 1px solid #e8e8e8; margin-bottom: 10px;"></div>
              <a-button style="float:right;margin-right:10px;" @click="cancel">取消</a-button>               
              <a-button style="float:right;margin-right:10px;" @click="saveAndCommit">保存并提交</a-button>
              <a-button type="primary" style="float:right;margin-right:10px;" @click="save">保存</a-button>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>
  import { httpAction, getAction, postAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { moneyFormatter, moneyParser, toDecimal } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import JSearchSelectTag from "@/components/dict/JSearchSelectTag"
  import JTreeSelect from "@/components/jeecg/JTreeSelect"
  import JUpload from '@/components/jeecg/JUpload'
  import { NewBusinessTypeDictOptions,AllBusinessTypeDictOptions } from '../../enums/businessTypeDictOptions'

  export default {
    name: 'BizBusinessinfoForm',
    description: '业绩补录',
    components: {
      JFormContainer,
      JDate,
      JDictSelectTag,
      JSearchSelectTag,
      JTreeSelect,
      JUpload
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data: function() {
      return {
        form: this.$form.createForm(this,{onValuesChange:this.formFieldValuesChange}),
        model: {},
        invoiceUnits:[],
        businessTypeDict:[],
        newBusinessTypeDictOptions:[],
        allBusinessTypeDictOptions:[],
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        confirmLoading: false,
        validatorRules: {
          businessType: {
            rules: [
              { required: true, message: '请选择业务类型!' },
              { validator: this.checkBusinessTypeShortName}
            ]
          },
         /* businessPerformanceType: {
            rules: [
              { required: true, message: '请选择业绩类型!' }
            ]
          },*/
          productOrLife: {
            rules: [
              { required: true, message: '请选择标的类型!' }
            ]
          },
          // date: {
          //   rules: [
          //     { required: true, message: '请输入日期!' }
          //   ]
          // },
          dep: {
            rules: [
              { required: true, message: '请选择部门!' }
            ]
          },
          project: {
            rules: [
              { required: true, message: '请选择项目!' },
              { validator: this.checkProjectShortName }
            ]
          },
          // broker: {
          //   rules: [
          //     { required: true, message: '请输入经纪人!' },
          //     { max: 20, message: '经纪人长度不能超过20' }
          //   ]
          // },
          insure: {
            rules: [
              { required: true, message: '请输入投保人!' },
              { max: 255, message: '投保人长度不能超过255个字符' },
              { whitespace: true, message:'不能为空格'}
            ]
          },
          insured: {
            rules: [
              { required: true, message: '请输入被保险人!' },
              { max: 255, message: '被保险人长度不能超过255个字符' },
              { whitespace: true, message:'不能为空格'}
            ]
          },
          insuredTel: {
            rules: [
              { required: false, message: '请输入被保险人联系方式!' },
              { max: 255, message: '被保险人联系方式长度不能超过255个字符' }
            ]
          },
          insuredAddr: {
            rules: [
              { required: false, message: '请输入被保险人通讯地址!' },
              { max: 255, message: '被保险人通讯地址长度不能超过255个字符' }
            ]
          },
          insurerNumber: {
            rules: [
              { required: true, message: '请选择保险公司!' },
              { validator: this.checkInsurerAgreement}
            ]
          },
          insuranceType: {
            rules: [
              { required: true, message: '请选择险种类型!' }
            ]
          },
          endNum: {
            rules: [
              { message: '请输入批单号' }
            ]
          },
          subjectName: {
            rules: [
             /* { required: true, message: '请输入标的名称!' }*/
            ]
          },
          insuranceName: {
            rules: [
              { required: true, message: '请输入险种名称!' },
              { max: 50, message: '险种名称长度不能超过50' },
              { whitespace: true, message:'不能为空格'},
              { validator: this.checkInsuranceType }
            ]
          },
          car: {
            rules: [
              //{ required: true, message: '请输入车牌号!'},
              { max: 10, message: '车牌号长度不能超过10' },
              { whitespace: true, message:'不能为空格'}
            ]
          },
          insuranceStart: {
            rules: [
              { required: true, message: '请输入保险起期!' }
            ]
          },
          insuranceEnd: {
            rules: [
              { required: true, message: '请输入保险讫期!' }
            ]
          },
          policy: {
            rules: [
              { required: true, message: '请输入保单号!' },
              { max: 30, message: '保单号长度不能超过30' },
              { whitespace: true, message:'不能为空格'}
            ]
          },
          insuredAmount: {
            rules: [
              { required: true, message: '请输入保额!' }
              // { type: 'number', message: '只能输入数值' },
            ]
          },
          rate: {
            rules: [
              { required: true, type: 'number', trigger: 'blur', message: '请输入费率(单位‰)!' }
              // { type: 'number', message: '只能输入数值' },
            ]
          },
          premium: {
            rules: [
              { required: true, type: 'number', trigger: 'blur', message: '请输入保费!' }
              // { type: 'number', message: '只能输入数值' },
            ]
          },
          cleanPremium: {
            rules: [
              { required: true, type: 'number', trigger: 'blur', message: '请输入去税保费!' }
              // { type: 'number', message: '只能输入数值' },
            ]
          },
          includeTax: {
            rules: [
              { required: true, message: '请选择是否含税!' }
            ]
          },
          brokerageRatio: {
            rules: [
              { required: true, type: 'number', trigger: 'blur', message: '请输入佣金比例!' }
              // { type: 'number', message: '只能输入数值' },
            ]
          },
          brokerageTotal: {
            rules: [
              { required: true, type: 'number', trigger: 'blur', message: '请输入总佣金!' }
              // { type: 'number', message: '只能输入数值' },
            ]
          },
          invoiceRatio: {
            rules: [
              { required: true, type: 'number', trigger: 'blur', message: '请输入开票比例!' }
              // { type: 'number', trigger: 'blur', message: '只能输入数值' },
            ]
          },
          invoiceAmount: {
            rules: [
              { required: true, type: 'number', trigger: 'blur', message: '请输入开票金额!' }
              // { type: 'number', message: '只能输入数值' },
            ]
          },
          outsideInvoiceAmount:{
            rules: [
              { type: 'number', trigger: 'blur', message: '开票金额只能是数字!' }
            ]
          },
          taxRate:{
            rules: [
              { required: true, type: 'number', trigger: 'blur', message: '发票税率只能是数字!' }
            ]
          },
          invoiceUnit:{
            rules: [
              { required: true, trigger: 'blur', message: '请选择开票单位!' }
            ]
          },
          phase: {
            rules: [
              { required: true, message: '请输入期数!' },
              { pattern:/^[1-9]\/[1-9]$/, message: '期数格式为1/3,表示第1期/共3期' }
            ]
          },
          agFlag: {
            rules: [
              { max: 30, message: '涉农标识长度超过30个字符' },
              { whitespace: true, message:'不能为空格'}
            ]
          },
          channel: {
            rules: [
              { required:true, message: '请选择所属渠道' }
            ]
          },
          internet: {
            rules: [
              { required:true, message: '请选择互联网标识' }
            ]
          },
          policyStatus: {
            rules: [

            ]
          },
          projectInfoId: {
            rules: [
              { required: true, message: '请选择立项名称' }
            ]
          },
          zone: {
            rules: [
              { max: 30, message: '区域长度超过30个字符' },
              { whitespace: true, message:'不能为空格'}
            ]
          }
        },
        url: {
          add: '/bms/bizBusinessinfo/add',
          edit: '/bms/bizBusinessinfoComplete/edit',
          queryById: '/bms/bizBusinessinfo/queryById',
          checkProjectShortName: '/bms/bizBusinessinfoProject/getShortName',
          checkBusinessTypeShortName: '/bms/bizBusinessinfoBusinessType/getShortName',
          checkInsurerAgreement: '/biz/bizAgreementinfo/judgeAgreementByCode',
	        checkInsuranceType: '/biz/insuranceWithType/getInsuranceTypeByName',
          getInvoiceUnit: "/sys/sysDepart/getInvoiceUnitByUser",
          updateFilePathImmediate: "/bms/bizBusinessinfo/updateFilePathImmediate",
        }
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
      showFlowSubmitButton(){
        return false
      }
    },

    created () {
      this.initInvoiceUnit();
      this.newBusinessTypeDictOptions = NewBusinessTypeDictOptions
      this.allBusinessTypeDictOptions = AllBusinessTypeDictOptions      
    },
    methods: {
      moneyFormatter,
      moneyParser,
      initInvoiceUnit(){
        this.invoiceUnits = []
        //根据当前登录用户获取能选择的开票单位
        getAction(this.url.getInvoiceUnit, {}).then((res) =>{
          if(res.success){
            this.invoiceUnits = res.result;
          }
        })
      },
      add () {
        this.edit({});
      },
      copyAdd (record) {
        //复制record
        let newRecord = JSON.parse(JSON.stringify(record));
        // 清空系统字段
        newRecord.id = null
        newRecord.createBy = null
        newRecord.createTime = null
        newRecord.updateBy = null
        newRecord.updateTime = null
        newRecord.invoiceNumber = null
        newRecord.invoiceTime = null
        newRecord.file = null  // 把文件置空，单据间不能共用文件，防止删除时存在其他引用
        newRecord.status = '0'
        this.edit(newRecord);
      },

      edit (record) {
        this.setBusinessTypeDictOptions()
        this.form.resetFields();
        if(record.channel == null || "" == record.channel) {
          record.channel = '0'
        }
        if(record.agFlag == null || "" == record.agFlag) {
          record.agFlag = '0'
        }
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => { //
          this.form.setFieldsValue(pick(this.model,'businessType','project','broker','insure','insured','insurerNumber',
            'productOrLife','insuranceType','insuranceName', 'car','insuranceStart','insuranceEnd','policy',
            'insuredAmount','rate','premium','cleanPremium','includeTax','brokerageRatio','brokerageTotal',
            'invoiceAmount','outsideInvoiceAmount','phase','zone','file','invoiceUnit','projectInfoId',
            'lifeInsurancePayType','channel','internet','policyStatus','subjectName','insuredTel','insuredAddr',
            'agFlag','endNum','insurer','taxRate', 'cleanBrokerage'))
        })
      },

      setBusinessTypeDictOptions() {
        if (this.disabled) { //详情，不可编辑
          this.businessTypeDict = this.allBusinessTypeDictOptions
        } else {//补录时，只能选择新业务类型
          this.businessTypeDict = this.newBusinessTypeDictOptions
        }
      },

      submitForm (isCommit) {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            //去除输入的两边空格
            this.trimFormData(formData);
            // 设置发票净额和税额（与导入、业绩录入口径一致：按总佣金计算，不再用开票金额）
            formData.invoiceCleanAmount = toDecimal(formData.brokerageTotal / (1 + formData.taxRate / 100))
            formData.taxAmount = formData.brokerageTotal - formData.invoiceCleanAmount
            // 设置保存时是否提交
            if(isCommit){
              formData.commitFlag = true
            } else {
              formData.commitFlag = false
            }

            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      trimFormData(formData){
        formData.insure = formData.insure ? formData.insure.trim(): ''
        formData.insured = formData.insured ? formData.insured.trim(): ''
        formData.insuranceName = formData.insuranceName ? formData.insuranceName.trim(): ''
        formData.car = formData.car ? formData.car.trim(): ''
        formData.policy = formData.policy ? formData.policy.trim(): ''
        formData.zone = formData.zone ? formData.zone.trim(): ''
      },

      // 校验业务类型简写是否存在
      checkBusinessTypeShortName(rule,value,callback){
        getAction(this.url.checkBusinessTypeShortName,{typeIndex: value}).then( (res) => {
          if(res.success){
            if(res.result != null && res.result != ''){
              callback()
            } else {
              callback("没有配置业务类型简写，请到【业务类型简写配置】功能中设置。")
            }
          } else {
            callback("没有配置业务类型简写，请到【业务类型简写配置】功能中设置。")
          }
        })
      },

      // 校验项目缩写是否存在
      checkProjectShortName(rule,value,callback){
        getAction(this.url.checkProjectShortName,{projectIndex: value}).then( (res) => {
          if(res.success){
            if(res.result != null && res.result != ''){
              callback()
            } else {
              callback("没有配置项目简写，请到【项目简写配置】功能中设置。")
            }
          } else {
            callback("没有配置项目简写，请到【项目简写配置】功能中设置。")
          }
        })
      },
      // 检查是否与保司签订协议, value:保司code
      checkInsurerAgreement(rule,value,callback){
        if(!value){ // 没有值
          callback()
        }
        getAction(this.url.checkInsurerAgreement,{companyCode: value}).then( (res) => {
          if(res.success){
            callback()
          } else {
            callback(res.message)
          }
        })
      },
   
    // 检查险种名称是否有对应的险种类型
    checkInsuranceType(rule, value, callback) {
      if (!value) { // 没有值
        callback()
      }
      this.form.setFieldsValue({ insuranceType: null }) // 先清空
      postAction(this.url.checkInsuranceType, { insuranceName: value }).then((res) => {
        if (res.success) {
          if (res.result) {
            let insuranceTypeId = res.result
            this.form.setFieldsValue({ insuranceType: insuranceTypeId })
            callback()
          } else {
            callback('此险种名称没有配置险种类型')
          }
        } else {
          callback('此险种名称没有配置险种类型')
        }
      })
    },
      // 开票金额改变,计算票外金额
      handleInvoiceAmountChange(val){
        // 获取总金额
        let brokerageTotal = this.form.getFieldValue('brokerageTotal')
        if(isNaN(brokerageTotal) || isNaN(val)){
          return
        }
        let outsideInvoiceAmount = toDecimal(brokerageTotal - val)
        this.form.setFieldsValue({outsideInvoiceAmount: outsideInvoiceAmount});
      },

      // 佣金比例改变
      brokerageRatioChange(newVal){
        // 保费
        let premium = this.form.getFieldValue('premium')
        // 净保费
        let cleanPremium = this.form.getFieldValue('cleanPremium')
        // 保险公司代码
        let insurerNumber = this.form.getFieldValue('insurerNumber')
	      //佣金是否含税
        let includeTax = this.form.getFieldValue('includeTax')
        let brokerageRatio = this.form.getFieldValue('brokerageRatio')

        let brokerageTotal;

        if(insurerNumber === 'TSCXJN' || includeTax === '1'){ // 泰山财险济南支公司
          if(!isNaN(premium) && !isNaN(newVal)){
            brokerageTotal = toDecimal(premium * newVal / 100)
            this.form.setFieldsValue({brokerageTotal: brokerageTotal}); // 总佣金
          }
        } else {
          if(!isNaN(cleanPremium) && !isNaN(newVal)){
            brokerageTotal = toDecimal(cleanPremium * newVal / 100)
            this.form.setFieldsValue({brokerageTotal: brokerageTotal}); // 总佣金
          }
        }
      },

      // 文件列表改变后及时更新数据库（编辑状态下）
      handleFileChange(filePath){
        // 编辑状态下变化，存在单据id
        let id = this.model.id
        if(id){
          postAction(this.url.updateFilePathImmediate, {id: id, filePath: filePath}).then(res =>{
            if(res.success){
            } else {
              this.$message.warn("附件更新时出现错误:" + res.message)
            }
          })
        }
      },

      // 监控表单中四个组件值变化，及时计算总佣金；此方式性能相对低；不如四个组件的onchange事件
      formFieldValuesChange(props, values){
        if(Object.keys(values).length > 1){ //form初始时不执行
          return
        }

        let includeTax = props.form.getFieldValue('includeTax')//是否含税
        let brokerageRatio = props.form.getFieldValue('brokerageRatio') //佣金比例
        let premium = props.form.getFieldValue('premium') //保费
        let cleanPremium = props.form.getFieldValue('cleanPremium') //净保费
        let insurerNumber =  props.form.getFieldValue('insurerNumber')

        if(values.includeTax){ //本次 设置是否含税
          includeTax = values.includeTax
        } else if(values.premium){          
          premium = values.premium 
        } else if(values.cleanPremium){          
          cleanPremium = values.cleanPremium
        } else if(values.brokerageRatio){          
          brokerageRatio = values.brokerageRatio
        } else { //非此四个字段的改变，直接返回
          return
        }

        if(!includeTax || !brokerageRatio || !insurerNumber){//是否含税、佣金比例 不能为空
          return
        }
        let brokerageTotal = 0
        if(includeTax ==='0' && cleanPremium){ //不含税，使用净佣金
          brokerageTotal = toDecimal(cleanPremium * brokerageRatio / 100)
          this.form.setFieldsValue({brokerageTotal: brokerageTotal}); // 总佣金
        }

        if((insurerNumber === 'TSCXJN' || includeTax === '1') && premium){// 泰山财险济南支公司/含税，使用佣金
          brokerageTotal = toDecimal(premium * brokerageRatio / 100)
          this.form.setFieldsValue({brokerageTotal: brokerageTotal}); // 总佣金
        }
      },

      //保存按钮事件
      save(e){
        this.submitForm(false)
      },
      // 保存并提交
      saveAndCommit(e){
        this.submitForm(true) 
      },
      // 取消保存
      cancel(e){
        this.$emit('cancel');
      },
    }
  }
</script>